import { FhirBinary, FhirResourceTypes, FhirResourceUtils } from '@oh-vcp/components-common';
import { useEffect } from 'react';

const useFhirResourceEffect = (
  data: any,
  setContent: React.Dispatch<React.SetStateAction<string>>,
  reportType: string,
  setSelectedClinicalReports: React.Dispatch<React.SetStateAction<string[]>>,
  enabled: boolean = true,
  setBinaryItems: React.Dispatch<React.SetStateAction<FhirBinary[]>>,
  references?: any
) => {
  useEffect(() => {
    if (!enabled) return;
    FhirResourceUtils.processFhirBundleResource(
      data,
      setContent,
      reportType,
      setSelectedClinicalReports,
      setBinaryItems,
      references
    );
  }, [data, enabled, references]);
};

export default useFhirResourceEffect;
